/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import { Link } from 'react-router-dom';
import '../Styles/styles-OnBoarding.css';
import Logo1 from '../Images/newlogo1-01.png'
import { OnBoardingNav } from "./Navigation/OnBoardingNav";
import { Carousel } from 'antd';


function onChange(a, b, c) {
    console.log(a, b, c);
  }

export class OnBoarding extends React.Component{
    state = {
        username:"",
        password: "",
        error: "",
        logged_in: false
    };
    render(){
        return <>

        <div>
            <OnBoardingNav />
            <div className="onboarding-spacing"></div>
            <div className="onboarding-content">
                <img className="onboarding-logo" src={Logo1} alt="header-logo"/>
                <p className="description-onboarding">Get actionable insights from your data, keep your players healthy, and <b className="onboarding-styled-text">WIN MORE GAMES!</b></p>
                <div className="onboarding-buttons">
                    {this.state.logged_in === true ? <Link to="/overview"><button className="onboarding-buttonA">Login</button></Link> : <Link to="/login"><button className="onboarding-buttonA">Login</button></Link> }
                    {/* <Link to="/features"><button className="onboarding-buttonB">Explore</button></Link> */}
                </div>
            </div>
            {/* Credit to: Mohammad Abdul Mohaiman, February 25, 2018 */}
            <div class="area" >
            <ul class="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
            </div>
        </div>
        </>
    }
}